import React from 'react';
import style from './style.module.scss';
import { DefaultButton } from '@magoosh/lib/button';
import practiceExams1and2Image from './practice_exams_1_2.png'
import practiceExams3and4Image from './practice_exams_3_4.png'
import practiceExams5and6Image from './practice_exams_5_6.png'
import { paths } from 'config/path_helpers';

const OfficialPracticeTestsCard: React.FC = (props) => <>
  <div className={style.officialPracticeTestsHeader}>
    <h1>
      Official GMAT Practice Tests
    </h1>
  </div>
  <p>
    We highly recommend taking advantage of the 6 full-length practice tests created by GMAC, the
    makers of the GMAT. Official Practice Exams feature real GMAT questions from past exams and
    are taken on MBA.com in an experience just like the actual GMAT.
  </p>
  <div className={style.practiceExamCards}>
    <div className={style.practiceExamCard}>
      <div>
        Practice Exams 1 &amp; 2
      </div>
      <div>
        <img src={practiceExams1and2Image} />
        Available for free<br/> on the GMAC website
      </div>
      <div>
        <DefaultButton href={'https://www.mba.com/exam-prep/gmat-official-starter-kit-practice-exams-1-and-2-free'}>
          Access Now
        </DefaultButton>
      </div>
    </div>
    <div className={style.practiceExamCard}>
      <div>
        Practice Exams 3 &amp; 4
      </div>
      <div>
        <img src={practiceExams3and4Image} />
        Request an Activation Code<br/> for free access through Magoosh
      </div>
      <div>
        <DefaultButton href={paths.subscriptions('ope3and4', 'GMATOPE34AC')}>
          Request Code
        </DefaultButton>
      </div>
    </div>
    <div className={style.practiceExamCard}>
      <div>
        Practice Exams 5 &amp; 6
      </div>
      <div>
        <img src={practiceExams5and6Image} />
        Request an Activation Code<br/> for free access through Magoosh
      </div>
      <div>
        <DefaultButton href={paths.subscriptions('ope5and6', 'GMATOPE56AC')}>
          Request Code
        </DefaultButton>
      </div>
    </div>
  </div>
  <p>
    Once you request an Activation Code, we&apos;ll email you with the code and instructions for
    how to redeem it on GMAC&apos;s website, mba.com, to get the tests. Your Official Practice
    Exams should arrive in about 3 hours, but can take up to 24 hours. Please request only one
    code per practice exam bundle.
  </p>
</>;

export default OfficialPracticeTestsCard;
